<template>
  <div class="wrapper">
    <div class="banner">
      <img src="../assets/imgs/home/banner.jpg" alt="" />
      <ul>
        <li>气象预见未来 双碳绿色发展</li>
        <li>深耕气象服务领域 积极应对气候变化</li>
        <li>践行“双碳”之路 发展低碳农业 营造绿色生态</li>
      </ul>
    </div>
    <div class="company-news">
      <img class="back" src="../assets/imgs/home/bkg1.png" alt="" />
      <div class="company-main">
        <h3>公司新闻</h3>
        <div class="card-group">
          <div
            class="card"
            v-for="item in list"
            :key="item.contentId"
            @click="toNews(item.contentId)"
          >
            <img :src="'https://api.giantweather.com' + item.typeImg" alt="" />
            <div class="card-desc">
              <span>{{ item.shortTitle || item.title }}</span>
            </div>
          </div>
        </div>
        <button
          @click="
            () => {
              $router.push('/news');
            }
          "
        >
          查看更多
        </button>
      </div>
    </div>
    <div class="production-server">
      <div class="production-server-main">
        <h3>产品与服务 — 气象与科技</h3>
        <div class="content">
          <div class="top">
            <img src="../assets/imgs/home/computer.png" alt="" srcset="" />
          </div>
          <div class="bottom">
            <div class="item" @click="toDataDetail">
              <img src="../assets/imgs/home/server1.png" alt="" />
              <span>气象数据加工</span>
            </div>
            <div class="item">
              <img src="../assets/imgs/home/server2.png" alt="" />
              <span>智慧农业气象</span>
            </div>
            <div class="item">
              <img src="../assets/imgs/home/server3.png" alt="" />
              <span>智慧工程气象</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="production-server2">
      <img class="back" src="../assets/imgs/home/bkg2.jpg" alt="" />
      <div class="production-server2-main">
        <h3>产品与服务 — 低碳与农业</h3>
        <div class="content">
          <div class="item">
            <img src="../assets/imgs/home/server4.png" alt="" srcset="" />
            <span>碳足迹，记录农业生产低碳活动</span>
          </div>
          <div class="item">
            <img src="../assets/imgs/home/server5.png" alt="" srcset="" />
            <span>碳计算，提供清晰碳排放量记录工具</span>
          </div>
          <div class="item">
            <img src="../assets/imgs/home/server6.png" alt="" srcset="" />
            <span>碳管理，实现企业绿色价值</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { contentList } from "../service/cms.js";
export default {
  name: "HomeView",
  data() {
    return {
      list: [],
    };
  },
  methods: {
    _contentList() {
      contentList(119, 1, 2).then(
        (res) => {
          if (res.code === 200 && res.success === true) {
            const data = res.data;
            this.list = data.records[0].contentList;
          }
        },
        (err) => {
          throw err;
        }
      );
    },
    toNews(id) {
      this.$router.push("/newsdetail/" + id);
    },
    toDataDetail() {
      this.$router.push("/meteorological/MPdata")
    }
  },
  mounted() {
    this._contentList();
  },
};
</script>
<style lang="less" scoped>
.wrapper {
  h3 {
    font-size: 22px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #1f2d39;
    text-align: center;
    padding: 37px 0;
  }
  .banner {
    position: relative;
    img {
      width: 100%;
    }
    ul {
      position: absolute;
      top: 80px;
      left: 143px;
      li {
        font-size: 16px;
        font-family: Source Han Sans CN;
        color: #f7f8f9;
        margin: 12px 0;
        &:nth-child(1) {
          font-size: 18px;
          font-weight: bold;
        }
      }
    }
  }
  .company-news {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    img.back {
      width: 750px;
      height: 532px;
      object-fit: contain;
    }
    .company-main {
      min-width: 638px;
      display: flex;
      flex-direction: column;
      align-items: center;
      position: absolute;
      top: 0;
      .card-group {
        width: 100%;
        display: flex;
        justify-content: space-between;
        .card {
          width: 297px;
          cursor: pointer;
          img {
            width: 297px;
            height: 220px;
            object-fit: cover;
          }
          .card-desc {
            background: #fff;
            text-align: center;
            padding: 22px;
            span {
              font-size: 14px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #1f2d39;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              width: 260px;
              display: block;
            }
          }
        }
      }
      button {
        width: 109px;
        height: 25px;
        border: 1px solid #bfbfbf;
        border-radius: 13px;
        margin-top: 53px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #666666;
        cursor: pointer;
      }
    }
  }
  .production-server {
    display: flex;
    flex-direction: column;
    align-items: center;
    .production-server-main {
      min-width: 750px;
      .content {
        display: flex;
        flex-direction: column;
        align-items: center;
        > .top {
          img {
            width: 458px;
          }
        }
        > .bottom {
          display: flex;
          align-items: center;
          padding: 60px 0;
          .item:first-child {
            cursor: pointer;
          }
          .item {
            display: flex;
            flex-direction: column;
            align-items: center;
            padding:  0  32px;
            > img {
              width: 82px;
            }
            > span {
              font-size: 16px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #1f2d39;
              padding:22px;
            }
          }
        }
      }
    }
  }
  .production-server2 {
    display: flex;
    flex-direction: column;
    align-items: center;
    background-image: url("../assets/imgs/home/bkg2.jpg");
    position: relative;
    img.back {
      width: 750px;
    }
    .production-server2-main {
      width: 750px;
      position: absolute;
      top: 0;
      h3 {
        color: #fff;
      }
      .content {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .item {
          display: flex;
          align-items: center;
          padding: 14px 200px;
          img {
            width: 60px;
          }
          span {
            font-size: 16px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #ffffff;
            margin-left: 26px;
          }
        }
      }
    }
  }
}
</style>
